const API_ERROR_KEY = /^[a-z][a-z0-9_]*$/

type Translate = (key: string, options?: { defaultValue?: string }) => string

export const isApiErrorKey = (value: string): boolean => {
  return API_ERROR_KEY.test(value)
}

export const translateApiError = (t: Translate, value: unknown): string => {
  if (value == null || value === '') return ''

  if (Array.isArray(value)) {
    return value.map((entry) => translateApiError(t, entry)).filter(Boolean).join(', ')
  }

  if (typeof value === 'object') {
    return Object.values(value as Record<string, unknown>)
      .map((entry) => translateApiError(t, entry))
      .filter(Boolean)
      .join(', ')
  }

  if (typeof value !== 'string') return String(value)

  if (!isApiErrorKey(value)) return value

  return t(`errors.api.${value}`, { defaultValue: value })
}
